module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0132.jpg?v=8575c9bb";